/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileWorkflowIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Workflow',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 2v10h10L20 2zM36 27.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V26h-2v6h2v-1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V34h-3.5a.5.5 0 0 1-.5-.5V30h-2v3.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V28h2v-3.5a.5.5 0 0 1 .5-.5H30v-1.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Z"
    />
    <path
      d="M15.5 33.5v-9a3 3 0 0 1 3-3h9.172A2.991 2.991 0 0 1 30 19.579V14H19a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h8.551a2.912 2.912 0 0 1-.051-.5Z"
    />
  </svg>`;
};
